import { render, staticRenderFns } from "./UpdateAccount.vue?vue&type=template&id=22588148&scoped=true"
import script from "./UpdateAccount.vue?vue&type=script&lang=js"
export * from "./UpdateAccount.vue?vue&type=script&lang=js"
import style0 from "./UpdateAccount.vue?vue&type=style&index=0&id=22588148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22588148",
  null
  
)

export default component.exports